//@ts-check
//@ts-ignore
import PcCheck from './pc-check.riot';
import { connect } from '@/common/lib/riot-redux';
import { ajaxPost } from '../ajax';
import { STATUS_FAILURE_PCMAIN_DUPLICATE, STATUS_FAILURE_PCMAIN_NOTREGISTER } from '@/common/constants';
import { pcCheckFailure, pcCheckRequest, pcCheckSuccess } from './pc.action';
import { router } from '@riotjs/route';
import storage from '@/common/storage';
import { hideLoading } from '@/common/components/kf-loader';
import { notifyOfficeLogin, notifyRestart } from '../vp-notify';

const mapStateToProps = (state, props) => {
  return {
    pcCheckError: state.app.pcCheckError,
    officeId: props.officeId,
    apiKey: props.apiKey
  };
};

const mapDispatchToProps = (dispatch) => ({
  restartVP() {
    notifyRestart();
  },

  async pcCheck({ officeId, apiKey, force }) {
    if (storage.isNoVp()) {
      router.push(`pc/register?officeId=${officeId}&apiKey=${apiKey}`);
      return;
    }
    const hwKey = sessionStorage.getItem('hwKey');
    dispatch(pcCheckRequest());
    try {
      const res = await ajaxPost('/vpmain', {
        method: 'check',
        officeId,
        apiKey,
        hwKey,
        force: !!force
      });
      storage.setOfficeId(officeId);
      storage.setApiKey(apiKey);
      dispatch(pcCheckSuccess(res));
      notifyOfficeLogin(officeId, apiKey);
      router.push(`login/staff?officeId=${officeId}&apiKey=${apiKey}`);
    } catch (e) {
      if (e?.status === STATUS_FAILURE_PCMAIN_NOTREGISTER) {
        router.push(`pc/register?officeId=${officeId}&apiKey=${apiKey}`);
      } else if (e?.status === STATUS_FAILURE_PCMAIN_DUPLICATE) {
        if (await window.openConfirm('他のメインPCがすでに起動されています。他のメインPCを終了しますか？')) {
          this.pcCheck({ officeId, apiKey, force: true });
        }
        dispatch(hideLoading());
        return;
      }
      dispatch(pcCheckFailure(e));
    }
  }
});

export default connect(PcCheck, mapStateToProps, mapDispatchToProps);